import { homepageUrlFromProperty } from "./homepage-url";

// Google's favicon endpoint. Domain properties (sc-domain:) are resolved to https://www.<domain>/.
export function propertyFaviconSrc(
  propertyUrl: string | undefined,
  size = 32
): string | null {
  const raw = propertyUrl?.trim();
  if (!raw) {
    return null;
  }
  const pageUrl = homepageUrlFromProperty(raw);
  if (!pageUrl) {
    return null;
  }
  return `https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${encodeURIComponent(
    pageUrl
  )}&size=${size}`;
}
